import './style.css';

export interface ButtonProps {
    title: string;   
    disabled?: boolean;
    onClick?: () => void;
}

function ButtonPrimary({ title, onClick, disabled = false }: ButtonProps) {
    return (
        <div className="container_button">
            <button className="container_button__primary" onClick={onClick} disabled={disabled}>{title}</button>
        </div>
    )
} 

export default ButtonPrimary;